import api from 'api';

export const loadNotifications = api('GET /api/profile/notifications');
export const markAsRead = api('POST /api/profile/notifications/:id/markasread');
export const markAllAsRead = api('POST /api/profile/notifications/markasread');
